export { default as useUncontrolled, useUncontrolledProp } from './hook';
export { default as uncontrollable } from './uncontrollable';


//////////////////
// WEBPACK FOOTER
// ./~/uncontrollable/lib/esm/index.js
// module id = 2488
// module chunks = 0